import React, { useState, useEffect } from 'react';
import '../../index.css';
import statisticsExampleImg from '../../icons/ic-MyPageStatistics.png';
import statisticsByTimeExampleImg from '../../icons/ic-MyPageStatisticsByTime.png';
import viewContentsStatisticsExampleImg from '../../icons/ic-ViewContentsStatistics.png';
import popularContentsExampleImg from '../../icons/ic-PopularContents.png';
import purchaseInduceRateExampleImg from '../../icons/ic-PurchaseInduceRate.png';

const StatisticsModal = (props) => {
  // 열기, 닫기, 모달 헤더 텍스트를 부모로부터 받아옴
  const { open, close, header } = props;

  return (
    // 모달이 열릴때 openModal 클래스가 생성된다.
    <div className={open ? 'openModal s_modal' : 's_modal'}>
      {open ? (
        <section>
          <header style={{ fontSize: 24, color: '#848484' }}>
            {'예시 이미지_' + header}
            <button onClick={close}>&times;</button>
          </header>

          <main>
            <div className="container">
              {header === '상품 통계' ? (
                <img
                  src={statisticsExampleImg}
                  style={{
                    display: 'inline-block',
                    height: '600px',
                    backfaceVisibility: 'hidden',
                    borderRadius: '20px',
                    imageRendering: '-webkit-optimize-contrast',
                    transform: 'translateZ(0)',
                  }}
                  alt={header}
                />
              ) : null}
              {header === '시간대별 상품 조회 순위' ? (
                <img
                  style={{
                    display: 'inline-block',
                    height: '600px',
                    backfaceVisibility: 'hidden',
                    borderRadius: '20px',
                    imageRendering: '-webkit-optimize-contrast',
                    transform: 'translateZ(0)',
                  }}
                  src={statisticsByTimeExampleImg}
                  alt={header}
                />
              ) : null}
              {header === '콘텐츠별 조회 순위' ? (
                <img
                  style={{
                    display: 'inline-block',
                    height: '600px',
                    borderRadius: '20px',
                    backfaceVisibility: 'hidden',
                    imageRendering: '-webkit-optimize-contrast',
                    transform: 'translateZ(0)',
                  }}
                  src={viewContentsStatisticsExampleImg}
                  alt={header}
                />
              ) : null}
              {header === '콘텐츠별 인기 상품' ? (
                <img
                  style={{
                    display: 'inline-block',
                    height: '600px',
                    borderRadius: '20px',
                    backfaceVisibility: 'hidden',
                    imageRendering: '-webkit-optimize-contrast',
                    transform: 'translateZ(0)',
                  }}
                  src={popularContentsExampleImg}
                  alt={header}
                />
              ) : null}
              {header === '구매 유도율' ? (
                <img
                  style={{
                    display: 'inline-block',
                    height: '600px',
                    borderRadius: '20px',
                    backfaceVisibility: 'hidden',
                    imageRendering: '-webkit-optimize-contrast',
                    transform: 'translateZ(0)',
                  }}
                  src={purchaseInduceRateExampleImg}
                  alt={header}
                />
              ) : null}
            </div>
          </main>
        </section>
      ) : null}
    </div>
  );
};

export default StatisticsModal;
